const Confirm = () => import('@/pages/access/Confirm.vue')
const SpecialistRegister = () => import('@/pages/specialist/SpecialistRegister.vue')
const CaseDocPrint = () => import('@/pages/cases/CaseDocPrint.vue')

export default {
  path: '/',
  name: 'NowrapPage',
  component: {
    render (c) { return c('router-view') }
  },
  children: [
    {
      path: 'confirm/:uid/:code',
      name: 'Confirm',
      component: Confirm,
      props: true,
      meta: {
        title: 'Подтверждение регистрации',  
      }
    },
    {
      path: 'specialist/register',
      name: 'SpecialistRegister',
      component: SpecialistRegister,
      meta: {
        title: 'Регистрация специалиста',
      }
    },
    { path: 'case/:caseId/doc/:docId/docprint', props: true, component: CaseDocPrint },
    { 
      path: 'extlogin/redirect/:name', 
      name: 'OauthRedirect',
      props: true, 
      component: () => import('@/pages/access/ext/Redirect.vue') 
    },
  ]
}